import $ from "jquery";
import Cookies from 'js-cookie';

export default class Theme {
    #$main;
    #$html;
    #$body;
    #utils;
    #slider;
    #scrollOffset;
    #scrollSpeed;
    #$header;

    constructor(
        utils,
        slider
    ) {
        this.#utils = utils;
        this.#slider = slider
        this.#$html = $('html');
        this.#$body = $('body');


        this.#scrollOffset =  -50;
        this.#scrollSpeed =  750;

        if (window.location.hash == "#dev") {
            Cookies.set("debug", 1);
        }
    }

    __onReady() {
        const me = this;
        this.#utils.log("Theme Ready");

        this.#slider.setup();

    }

    __onLoad() {
        const me = this;
        this.#utils.log("Theme Load");

        this.#slider.show();

    }

    __onResize() {

    }

    get utils() {
        return this.#utils;
    }
}